import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    async getNotifications(params) {
        return await Axios.get(`${baseURL}actor/notification`, {
            params: params,
            time: new Date().getTime() // prevent cache
        });
    },

    async getNotificationCount(params) {
        return await Axios.get(`${baseURL}actor/notification-count`, {
            params: params
        });
    },

    async dismiss(ids = []) {
        return await Axios.put(`${baseURL}actor/dismiss-notification`, {
            notification_id: ids
        });
    }
};
